import { render } from "./AudioPlayer.vue?vue&type=template&id=9f5b5de4"
import script from "./AudioPlayer.vue?vue&type=script&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&lang=js"

import "./AudioPlayer.vue?vue&type=style&index=0&id=9f5b5de4&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__